// -----------------------------------------------
export function scrollToItemByGroup(group, smooth = true) {
  const scrollItem = document.querySelector(`[scroll-group="${group}"]`)
  const scrollWrapper = document.querySelector(`[scroll-wrapper="scroll-wrapper"]`)
  if (scrollItem && scrollWrapper) {
    const itemRect = scrollItem.offsetTop // [UPDATED]
    // const wrapperRect = scrollWrapper.offsetTop // [UPDATED]
    scrollWrapper.style.scrollBehavior = smooth ? 'smooth' : 'auto'
    scrollWrapper.scrollTo(0, itemRect)
  }
}

// -----------------------------------------------
export function scrollToItemByIndex(index) {
  const scrollItem = document.querySelector(`[scroll-index="${index}"]`)
  const scrollWrapper = document.querySelector(`[scroll-wrapper="scroll-wrapper"]`)
  if (scrollItem && scrollWrapper) {
    const itemRect = scrollItem.offsetTop // [UPDATED]
    // const wrapperRect = scrollWrapper.offsetTop // [UPDATED]
    scrollWrapper.scrollTo(0, itemRect)
  }
}

// -----------------------------------------------
export function scrollToCenterItemByIndex(index) {
  const scrollItem = document.querySelector(`[scroll-index="${index}"]`)
  const scrollWrapper = document.querySelector(`[scroll-wrapper="scroll-wrapper"]`)
  if (scrollItem && scrollWrapper) {
    const itemRect = scrollItem.offsetTop // [UPDATED]
    const wrapperRect = scrollWrapper.offsetTop // [UPDATED]
    scrollWrapper.scrollTo(0, itemRect - wrapperRect)
  }
}

// -----------------------------------------------
